module.exports = __webpack_public_path__ + "img/Pic_Support-2_a.89230058.jpg";